import * as types from '../constants/auditdetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  auditdetails: null,
  //templatedetailsList: null
}

export function auditDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_AUDIT_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_AUDIT_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        auditdetails: action.data
      };
    case types.FETCH_AUDIT_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // templatedetailsList:action.error
      };
    case types.FETCH_AUDIT_LIST_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        auditdetails: null,
      };    
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/auditdetails.js